import type { EntityHistoryReducerState } from './entityHistory.types';

export const entityHistoryInitialState: EntityHistoryReducerState = {
  enitityData: {}
};
